export default {
  name: "TagSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 2H17.79c-.53 0-1.03.21-1.41.59L2.63 16.34a2 2 0 0 0 0 2.83l10.21 10.21c.39.39.9.58 1.41.58s1.02-.19 1.41-.58l13.76-13.74c.38-.38.59-.88.59-1.41V4C30 2.9 29.1 2 28 2zm-7.5 12.5c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z",
  },
}
